/**
 * @file
 * @auth jinguangguo
 * @date 2016/10/18
 */


$(function () {
    let $module = $('.layout-nav');

    if ($module[0]) {
        $module.find('.js-nav').click(function (e) {
            e.preventDefault();
            let href = $(this).attr('data-href');

            // 跳转到首页
            if (href.indexOf('index.html') >= 0) {
                window.location.href = './index.html';
                return;
            }

            // 跳转到合约页面
            if (href.indexOf('contract.html') >= 0) {
                window.location.href = './contract.html';
                return;
            }
        });
    }
});






// WEBPACK FOOTER //
// ./src/include/nav/nav.js